<template>
<div class="widget-task-list">

    <div class="task-details">
        
      <!----  <h4>Case Submitted dfsdfdsf</h4>-->
        <p><a @click="goToPageDetails('/beneficiaries-details/'+checkProperty( itemData,'_id'))">{{checkProperty( itemData,'name')}}</a></p>
        <em v-if="checkProperty( itemData,'customId')"><a @click="goToPageDetails('/beneficiaries-details/'+checkProperty( itemData,'_id'))">{{checkProperty( itemData,'customId')}}</a></em>
       
        <ul>
            <li class="cursor" v-on:click.stop.prevent="navigation('caseCount')"  v-if="checkProperty( itemData,'caseCount') >0">Cases: {{checkProperty( itemData,'caseCount')}} <span></span></li>           
        </ul>
    </div>
    <div class="task-status" >

        <ul >

        <li class="cursor" v-if="checkProperty( itemData,'statusDetails' ,'name')"
        
        v-on:click.stop.prevent="navigateToDetails(itemData ,'BENEFICIARY_LIST' ,'statusIds')" 
         >
            <span class="statusspan cursor"
            
               v-bind:class="{
                    'status_created': checkProperty(itemData ,'statusDetails','id') == 1,
                    'status_submited': checkProperty(itemData ,'statusDetails','id') == 2,
                    'status_inProcess': checkProperty(itemData ,'statusDetails','id') == 3,
                    'status_waiting': checkProperty(itemData ,'statusDetails','id') == 4,
                    'status_ready_for_filing': checkProperty(itemData ,'statusDetails','id') == 5,
                    'status_sent_for_signatures': checkProperty(itemData ,'statusDetails','id') == 6,
                    'staus_filed_with_USCIS': checkProperty(itemData ,'statusDetails','id') == 7,
                    'Status_received_by_USCIS': checkProperty(itemData ,'statusDetails','id') == 8,
                    'status_approved': checkProperty(itemData ,'statusDetails','id') == 9,
                    'status_denied': checkProperty(itemData ,'statusDetails','id') == 10,
                    'RFE_Received': ['11',11].indexOf(checkProperty(itemData ,'statusDetails','id')) >-1,
                    'response_to_RFE_Filed': checkProperty(itemData ,'statusDetails','id') == 12,
                    'response_to_RFE_Received': checkProperty(itemData ,'statusDetails','id') == 13,
                    'status_withdrawn': checkProperty(itemData ,'statusDetails','id') == 14,
                    ' ': checkProperty(itemData ,'statusDetails','id') == 15
                  }"
            
            >{{checkProperty( itemData,'statusDetails' ,'name')}}</span>
                
            </li>
            <!---
            <li>
            <a href="#" class="approve-btn"></a>
            </li>
            <li>
            <a href="#" class="close-btn"></a>
            </li>
            <li>
            <a href="#" class="upload-btn"></a>
            </li>
            -->
        </ul>
        <p  v-if="checkProperty( itemData,'updatedOn')" class="task-timing"> {{ checkProperty( itemData,'updatedOn') | timeago}}</p>
    </div>
</div>                  

</template>
<script>
    export default {
     name:'caseByStatus',
     props: {
        widgetData:null,
        itemData:null
     },
     methods:{
        navigation(callFrom=''){
            let itemData = _.cloneDeep(this.itemData);
           // itemData = Object.assign(itemData,{'filterItems':{}});
            //branchIds

           let filterItems ={};
            
            if(callFrom=='caseType'){
                if(this.checkProperty(itemData,'type')){
                    filterItems['typeIds'] = [itemData['type']];
                 
                }
                
                
                

            }else if(callFrom=='caseSubType'){
                //subTypeIds
                if(this.checkProperty(itemData,'type')){
                    filterItems['typeIds'] = [itemData['type']];
                 
                }
                if(this.checkProperty(itemData,'subType')){
                    filterItems['subTypeIds'] = [itemData['subType']];
                 
                }

            }else if(callFrom=='activeCases'){
                
                filterItems['getActiveCases'] = true;

            }else if(callFrom=='closedCases'){

                if(this.checkProperty(itemData,'type')){
                    filterItems['typeIds'] = [itemData['type']];
                 
                }
                filterItems['getFiledCases'] = true;
                
                if(this.checkProperty(itemData,'subType')){
                    filterItems['subTypeIds'] = [itemData['subType']];
                 
                }
                filterItems['getFiledCases'] = true;

            }else if(callFrom=='status'){
             //statusIds
            }else if( callFrom=='caseCount'){

                if(this.checkProperty(itemData,'_id')){
                filterItems['beneficiaryIds'] = [itemData['_id']];
                
               }
                
                if(this.checkProperty( itemData,'petitionerId')){
                    filterItems['petitionerIds'] = [itemData['petitionerId']];
                }
                

            }
            if(this.checkProperty(Object.keys(filterItems) ,'length') >0){

                itemData = Object.assign(itemData,{'filterItems':{}});
                itemData['filterItems'] =filterItems;
            }

            this.navigateToDetails(itemData ,'CASE_LIST' ,'multiFilters');


        }

     }
    
    
    }
    </script>